import { FC, jsx } from 'alumina';

export const FirmwareFlashPage: FC = () => {
  return <div>unimplemented yet</div>;
};
